import { useQuery } from '@tanstack/react-query';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import {
  DocumentSummary,
  EditDocumentsInput,
  EditDocumentsOutput,
} from './types';

export { DocumentOperationOrigin } from './types';

export const updateArrearRate = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'patch',
    url: 'internal/document/arrearRate',
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const editDocuments = async (
  dispatch: Dispatch,
  data: EditDocumentsInput,
): Promise<EditDocumentsOutput | undefined> => {
  const response = await requestHandler({
    method: 'patch',
    url: 'internal/document/editDocuments',
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentReport = (dispatch: Dispatch, documentId: string) =>
  useQuery({
    queryKey: ['document', documentId, 'report'],
    queryFn: async (): Promise<DocumentSummary | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/report/document/${documentId}`,
        dispatch,
      });
      if (response) return response.data;
    },
    retry: 1,
    refetchOnWindowFocus: false,
  });

export async function getCessionCertificate(
  dispatch: Dispatch,
  documentId: string,
  signal?: AbortSignal,
): Promise<Blob | undefined> {
  const response = await requestHandler({
    responseType: 'blob',
    method: 'get',
    url: `internal/collection/cessionsCertificate/${documentId}`,
    signal,
    dispatch,
  });
  if (response) return response.data;
}
